import React from 'react';
import { TriangleAlert } from 'lucide-react';

export default function AlertBanner({ alert }) {
  if (!alert) {
    return (
      <div className="alert-banner alert-banner--idle">
        <span className="dot dot--ok" />
        No active contamination alerts
      </div>
    );
  }

  const classes = (alert.detections || []).map((item) => item.class).join(', ');
  return (
    <div className="alert-banner alert-banner--danger">
      <TriangleAlert size={18} />
      <strong>{alert.camera}</strong>
      <span>{classes || 'Contamination detected'}</span>
      <small>{alert.timestamp}</small>
    </div>
  );
}
